import { environment } from '../../environments/environment';

export const apiLandingProduct = `/api/v2/products/landing-product`;
export const apiProducts = `${environment.host}/products`;
export const apiPartners = `${environment.host}/partners`;
export const apiPayments = `${environment.host}/payments`;
export const availabilityApiUrl = `/api/v2/availability`;

export const keys = {
  cartOptions: 'cartOptions',
};
